module.exports = __webpack_public_path__ + "static/img/business4.0d7b333.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/business4.png
// module id = OpAe
// module chunks = 1